import { Parametro } from './parametro';
import { ConvocatoriaDet } from '.';

export class ParametrosBandeja {
  ListaConvocatoria: Array<ConvocatoriaDet>;
  ListaTipoGrupo: Array<Parametro>;
  ListaEstadosFormulario: Array<Parametro>;
}
